export default __webpack_public_path__ + "static/media/003-buoy.05840fde.svg";